import type { InputHTMLAttributes, ReactNode } from "react";
import styles from "./Field.module.css";

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
  error?: string;
}

export function TextField({
  label,
  hint,
  error,
  id,
  className,
  ...rest
}: TextFieldProps) {
  const inputId = id ?? `field-${label.replace(/\s+/g, "-")}`;
  return (
    <label className={styles.field} htmlFor={inputId}>
      <span className={styles.label}>{label}</span>
      <input
        id={inputId}
        className={[styles.input, error ? styles.error : "", className ?? ""]
          .filter(Boolean)
          .join(" ")}
        {...rest}
      />
      {error ? (
        <span className={styles.errorText}>{error}</span>
      ) : hint ? (
        <span className={styles.hint}>{hint}</span>
      ) : null}
    </label>
  );
}

interface CheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "children"> {
  children: ReactNode;
}

export function Checkbox({ children, ...rest }: CheckboxProps) {
  return (
    <label className={styles.checkbox}>
      <input type="checkbox" {...rest} />
      <span>{children}</span>
    </label>
  );
}
